import { render, staticRenderFns } from "./ConversationQuickResponse.vue?vue&type=template&id=130913c8&scoped=true&"
import script from "./conversation-quick-response.ts?vue&type=script&lang=ts&"
export * from "./conversation-quick-response.ts?vue&type=script&lang=ts&"
import style0 from "./conversation-quick-response.scss?vue&type=style&index=0&id=130913c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130913c8",
  null
  
)

export default component.exports